import * as $ from 'jquery';

require('datatables.net');
require('datatablesResponsive');

function dynamicTable():any{
    $('table#campaign-table').DataTable();
}

let scope:Element = document.querySelector('#campaign-table');

if (scope){
	try {
        dynamicTable();
	} catch(e) {console.error(e);}
}